/** Strategem 110 (Pulse Shockwave) & 51 (Culling Protocol) — vertical double shockwave; 110 adds slot damage labels */
export const PULSE_SHOCKWAVE_SOUND_PATH = '/sounds/shockwave.mp3';
/** Strategem 57 (Swarm Collapse) — same wave animation, red/black palette */
export const SWARM_COLLAPSE_SOUND_PATH = '/sounds/swarm_collapse.mp3';
/** Total time before overlay unmounts (matches CSS sweep + damage pop tail) */
export const PULSE_SHOCKWAVE_DURATION_MS = 1480;
